<button type="button" mat-icon-button color="{{color}}" (click)="$event.stopPropagation(); openDialog()" [matTooltip]="infoTextTranslation?.descriptionShort ?? ''" matTooltipClass="unlimited-size-tooltip">
  <mat-icon>info</mat-icon>
</button>
